const requestInterceptor = (() => {
    const interceptXHR = () => {
        const originalOpen = XMLHttpRequest.prototype.open;
        const originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
            this._url = url; // Store the URL being requested
            return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function(body) {
            if(!this._url)
              return originalFetch.apply(this, arguments);
          
            if (this._url.includes('/cart/add')) {
                document.dispatchEvent(new CustomEvent('cart:add', { detail: this._url }));
            }
            if (this._url.includes('/cart/change')) {
                document.dispatchEvent(new CustomEvent('cart:change', { detail: this._url }));
            }
            if (this._url.includes('/cart/clear')) {
                document.dispatchEvent(new CustomEvent('cart:clear', { detail: this._url }));
            }
            if (this._url.includes('/cart/update')) {
                document.dispatchEvent(new CustomEvent('cart:update', { detail: this._url }));
            }
            return originalSend.apply(this, arguments);
        };
    };

    const interceptFetch = () => {
        const originalFetch = window.fetch;

        window.fetch = function(input, init) {
            const url = (typeof input === 'string') ? input : input.url;

            if(!url)
              return originalFetch.apply(this, arguments);
          
            if (url.includes('/cart/add')) {
                document.dispatchEvent(new CustomEvent('cart:add', { detail: url }));
            }
            if (url.includes('/cart/change')) {
                document.dispatchEvent(new CustomEvent('cart:change', { detail: url }));
            }
            if (url.includes('/cart/clear')) {
                document.dispatchEvent(new CustomEvent('cart:clear', { detail: url }));
            }
            if (url.includes('/cart/update')) {
                document.dispatchEvent(new CustomEvent('cart:update', { detail: url }));
            }
            return originalFetch.apply(this, arguments);
        };
    };

    const init = () => {
        interceptXHR();
        interceptFetch();
    };

    return {
        init
    };
})();

